import React, { useEffect, useMemo, useRef, useState } from "react";
import ButtonComponent from "../../../components/common/button/Button";
import { useNavigate } from "react-router-dom";
import "../analyticsresults/AnalyticsResults.css";
import TopSection from "../TopSection";
import Cards from "../../../components/common/card/Card";
import { useLocation } from "react-router-dom";
import { TextareaAutosize } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ApproverPendingApprovalHeaders } from "../ApproverColumnHeaders/ColumnHeaders/ApproverPendingApprovalHeaders";
import { ApproverClosedWorkflowHeaders } from "../ApproverColumnHeaders/ColumnHeaders/ApproverClosedWorkflowHeaders";
import { getApproverResultsData } from "../../../redux/actions/LTApprover/GetApproverResultsSlice";
import { addApproversEndpoint, getApproverResultsEndpoint, getLTApproverHideColumnsEndpoint, getViewAllDetailsEndpoint, postLTApproverHideColumnsEndpoint, rejectPlannerByApproverEndpoint, rejectToInitiatorEndpoint, reSubmitWorkflowEndpoint, sendToNextLevelApproverEndpoint } from "../../../common/endpoints";
import { Loader } from "../../../components/common/Loader";
import { FinalLTUpdateModal } from "../analyticsresults/FinalLTUpdateModal";
import DataTable from "../../../components/common/datatable/DataTable";
import { rejectPlannerByApprover } from "../../../redux/actions/LTApprover/RejectPlannerByApproverSlice";
import { SendToNextLevel } from "./SendToNextLevelModal";
import { sendToNextLevelApprover } from "../../../redux/actions/LTApprover/SendToNextLevelSlice";
import LeadtimeModel from "../analyticsresults/LeadTimeModal";
import { getViewAllDetails } from "../../../redux/actions/ViewAllLineItemsDataSlice";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Popover, Select, MenuItem, Checkbox, ListItemText, IconButton, Badge, Box, CircularProgress } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { getApproverHideColumnsAPI } from "../../../redux/actions/HideColumns/GetApproverHideColumns";
import { postApproverHideColumnsAPI } from "../../../redux/actions/HideColumns/PostApproverHideColumns";
import { resubmitByApprover } from "../../../redux/actions/LTApprover/ResubmitSlice";
import LeadTimeLineGraph from "../LeadTimeLineGraph";
import OutBoundDataModal from "../OutBound/OutBoundDataModal";
import CPLeadTimeModal from "../ContractPIRLeadTimeModal/CPLeadTimeModal";
import { postRejectToInitiator } from "../../../redux/actions/RejectToInitiatorSlice";
import { AddExtraApproverModal } from "./AddExtraApproverModal";
import { addExtraApproversAPI } from "../../../redux/actions/LTApprover/AddExtraApproversSlice";
import { setSelectedItem } from "../../../redux/actions/SupportTicket/selectionSlice";
import { VariantViewModal } from "../VariantView/VariantViewModal";
import { ShowVariantViewModal } from "../VariantView/ShowVariantViewModal";
import TextInput from "../../../components/common/TextInput";

const ApproverManagement = () => {
    const role = localStorage.getItem("LTRole");
    const userEmail = localStorage.getItem("data");
    const dispatch = useDispatch();
    const stateSelector = useSelector((state) => state);
    const [rowData, setRowData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isSubmitToS4Enabled, setIsSubmitToS4Enabled] = useState([]);
    const [isResubmitEnabled, setIsResubmitEnabled] = useState([]);
    const [openFinalLTUpdateModal, setOpenFinalLTUpdateModal] = useState(false);
    const [activeItem, setActiveItem] = useState(localStorage.getItem("approverActiveItem") || "Pending Approval");
    const [editedRows, setEditedRows] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [textAreaValue, setTextAreaValue] = useState("");
    const [bulkPDTValue, setBulkPDTValue] = useState("");
    const bulkPDTBaseRowsRef = useRef([]);
    const [bulkPDTDisabled, setBulkPDTDisabled] = useState(true);
    const { state } = useLocation();
    const gridRef = useRef();
    const currentPageRef = useRef(0);
    const [gridApi, setGridApi] = useState();
    const [buttonLabel, setButtonLabel] = useState("Approve & Send to Next Level");
    const [equalCount, setEqualCount] = useState(0);
    const [nonEqualCount, setNonEqualCount] = useState(0);
    const [rejectedCount, setRejectedCount] = useState(0);
    const [openViewAllModal, setOpenViewAllModal] = useState(false);
    const [viewAllData, setViewAllData] = useState({});
    const [columnFilterDropdownOption, setColumnFilterDropdownOption] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [openLineGraph, setOpenLineGraph] = useState(false);
    const [lineGraphSelectedValue, setLineGraphSelectedValue] = useState(false);
    const [badgeCount, setBadgeCount] = useState();
    const [disableRejectToInitiator, setDisableRejectToInitiator] = useState(true);
    const [openCreateVariantModal, setOpenCreateVariantModal] = useState(false);
    const [openShowVariantModal, setOpenShowVariantModal] = useState(false);
    const [variantData, setVariantData] = useState({});
    const savedFilterModel = localStorage.getItem("savedVariantFilterModel");

    const [openOutboundModal, setOpenOutboundModal] = useState(false);
    const [outboundData, setOutboundData] = useState({});
    const [selectedName, setSelectedName] = useState("");

    const [leadTimeName, setLeadTimeName] = useState("");
    const [openLeadTimeModal, setOpenLeadTimeModal] = useState(false);
    const [leadTimeData, setLeadTimeData] = useState({});

    const [disableFilterBtn, setDisableFilterBtn] = useState(true);

    const { instance } = useMsal();
    const landingCardTitle = state || "High LT Variation";
    const variationRanking = landingCardTitle === "Medium LT Variation" ? { "High": 3, "Medium": 2, "Low": 1 } : landingCardTitle === "Low LT Variation" ? { "High": 2, "Medium": 1, "Low": 3 } : { "High": 3, "Medium": 2, "Low": 1 };

    useEffect(() => {
        getWorkFlowData();
    }, [])
    useEffect(() => {
        const savedPage = localStorage.getItem("lastVisitedPage");
        if (savedPage !== null) {
            currentPageRef.current = Number(savedPage);
        }
    }, []);
    const checkVariantFilter = () => {
        if (!gridApi) return;

        if (savedFilterModel) {
            try {
                const parsedFilterModel = JSON.parse(savedFilterModel);
                gridApi.setFilterModel(parsedFilterModel);
                gridApi.onFilterChanged();
            } catch (e) {
                console.error("Error parsing saved filter model:", e);
            }
        }
    }
    const getWorkFlowData = async () => {

        try {
            const responseAnaltics = await dispatch(getApproverResultsData({
                dynamicEndpoint: `${getApproverResultsEndpoint}/${userEmail}`,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responseAnaltics?.meta?.requestStatus === 'fulfilled') {
                setTextAreaValue("");
                gridApi?.deselectAll();
                setRowData(responseAnaltics?.payload?.records[0]);
                getFilterUpdateData(responseAnaltics?.payload?.records[0]);
                checkVariantFilter();
            } else {
                console.error('Failed to fetch data:', responseAnaltics?.error);
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    const getFilterUpdateData = (data) => {
        const mapRow = (row, index) => {
            const finalLt =
                row.recomConfidenceLevel === "75%"
                    ? row.likelyFinalLt || 0
                    : row.recomConfidenceLevel === "65%"
                        ? row.lessLikelyFinalLt || 0
                        : row.highLikelyFinalLt || 0;

            const currLt = Number(
                row?.purchDocType === "Y1"
                    ? row?.contractLt?.split(" ")[0]
                    : row?.activePirLt?.split(" ")[0]
            );

            const ratio = Math.sqrt(Number(finalLt) / currLt);
            const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

            const inventoryChange =
                (row?.currentAvgStock - row?.oldSafetyStock + (row?.oldSafetyStock * ratio)) -
                row?.currentAvgStock;

            let inventoryValue = (row?.actualPrice * inventoryChange).toFixed(2);

            return {
                ...row,
                finalLt,
                potentialImpact,
                inventoryValue,
                index,
            };
        };
        if (activeItem === "Pending Approval") {
            setFilteredData(data?.pendingApprovalItems?.map(mapRow));
        }
        if (activeItem === "Closed Workflow Items") {
            setFilteredData(data?.closedWorkflowItems?.map(mapRow));
        }
    }

    const mapRowWithCalculations = (row) => {
        const finalLt =
            row.recomConfidenceLevel === "75%"
                ? row.likelyFinalLt || 0
                : row.recomConfidenceLevel === "65%"
                    ? row.lessLikelyFinalLt || 0
                    : row.highLikelyFinalLt || 0;

        const currLt = Number(
            row?.purchDocType === "Y1"
                ? row?.contractLt?.split(" ")[0]
                : row?.activePirLt?.split(" ")[0]
        );

        const ratio = Math.sqrt(Number(finalLt) / currLt);
        const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

        const inventoryChange =
            (row?.currentAvgStock - row?.oldSafetyStock + (row?.oldSafetyStock * ratio)) -
            row?.currentAvgStock;

        let inventoryValue = (row?.actualPrice * inventoryChange).toFixed(2);

        return {
            ...row,
            finalLt,
            potentialImpact,
            inventoryValue,
        };
    };

    const pendingActionData = rowData?.pendingActionItems?.map(mapRowWithCalculations);
    const pendingApprovalData = rowData?.pendingApprovalItems?.map(mapRowWithCalculations);
    const closedData = rowData?.closedWorkflowItems?.map(mapRowWithCalculations);

    const pagination = true;
    const paginationPageSize = 500;
    const paginationPageSizeSelector = [10, 50, 100, 500, 1000];
    const navigate = useNavigate();

    const onGridReady = (params) => {
        setGridApi(params?.api);
        gridRef.current = params?.api;
    }

    const onPaginationChanged = () => {

        if (gridRef.current && !gridRef.current.isDestroyed()) {
            const currentPage = gridRef.current.paginationGetCurrentPage();
            currentPageRef.current = currentPageRef.current || currentPage;
            localStorage.setItem("lastVisitedPage", currentPage);
        }
    };
    const onFirstDataRendered = () => {
        if (gridRef.current && !gridRef.current.isDestroyed()) {
            gridRef.current.paginationGoToPage(currentPageRef.current || 0);
            localStorage.setItem("lastVisitedPage", currentPageRef.current);
        }
    };

    const getApproverHideColumnsData = async () => {
        try {
            const responseHideApproverData = await dispatch(getApproverHideColumnsAPI({
                dynamicEndpoint: `${getLTApproverHideColumnsEndpoint}/${userEmail}`,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responseHideApproverData?.meta?.requestStatus === 'fulfilled') {
                setSelectedColumns(responseHideApproverData?.payload);
                setBadgeCount(responseHideApproverData?.payload?.length);
                const hideDropdownOptions = regularItemsData?.filter((item) => item?.optionalField === true);
                setColumnFilterDropdownOption(hideDropdownOptions);
                const displayedColumns = regularItemsData.filter(
                    col => !col.optionalField || !responseHideApproverData?.payload?.includes(col.headerName)
                );
                setFilteredColumnsData([...displayedColumns]);
            } else {
                console.error('Failed to fetch data:', responseHideApproverData?.error);
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }
    useEffect(() => {
        getApproverHideColumnsData()

    }, [])

    useEffect(() => {
        if (activeItem === "Pending Approval") {
            setFilteredData(pendingApprovalData)
        }
        else if (activeItem === "Closed Workflow Items") {
            setFilteredData(closedData)
        }
        setSelectedRows([]);
        setEditedRows([]);
        setEqualCount(0);
        setNonEqualCount(0);
        setRejectedCount(0);
        setButtonLabel("Approve & Send to Next Level");
        setTextAreaValue("")
    }, [activeItem, navigate, dispatch, role]);

    const updateButtonLabel = (rows) => {
        const equalCount = rows.filter(row => (row.currentApprovalLevel === row.totalApprovalLevels) && !row.currentStatus?.includes("Rejected")).length;
        const nonEqualCount = rows.filter(row => (row.currentApprovalLevel !== row.totalApprovalLevels) && !row.currentStatus?.includes("Rejected")).length;
        const rejectedCount = rows.filter(row => row.currentStatus?.includes("Rejected")).length;
        const rejectToInitiatorCount = rows.filter(row => (row.currentApprovalLevel === 1))

        setEqualCount(equalCount);
        setNonEqualCount(nonEqualCount);
        setRejectedCount(rejectedCount);
        setDisableRejectToInitiator(rejectToInitiatorCount?.length === 0 ? false : true)

        let label = "Approve & Send to Next Level";
        if (equalCount === 0 && nonEqualCount > 0) label = "Approve & Send to Next Level";
        if (equalCount > 0 && nonEqualCount === 0) label = "Send to S/4";
        if (equalCount > 0 && nonEqualCount > 0) label = "Approve & Send to Next Level";

        setButtonLabel(label);
    };

    const onChangeConfidenceLevel = (params) => {
        // console.log("Entered ", params);
    }

    const cellEditorParams = {
        getPopUpPosition: () => "under",
        popup: true,
        editorStyle: {
            width: "60px"
        }

    }
    const getViewAllData = async (row) => {
        try {
            const responseViewAllDetails = await dispatch(getViewAllDetails({
                dynamicEndpoint: `${getViewAllDetailsEndpoint}/${row.runSeqId}`,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responseViewAllDetails?.meta?.requestStatus === 'fulfilled') {
                setViewAllData(responseViewAllDetails?.payload)
            } else {
                console.error('Failed to fetch data:', responseViewAllDetails?.payload?.errorMessage);
                setViewAllData({})
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }
    const handleOpenViewAllModal = (row) => {
        setOpenViewAllModal(true);
        getViewAllData(row);
    }
    const handleCloseViewAllModal = (row) => {
        setOpenViewAllModal(false);
        setViewAllData({})
    }
    const handleOpenLineGraphModal = (row) => {
        setOpenLineGraph(true);
        setLineGraphSelectedValue(row)
    }
    const handleCloseLineGraphModal = () => {
        setOpenLineGraph(false);
    }
    const handleSaveLineGraphModal = (row) => {
        setOpenLineGraph(false);
        const currentAvgStock = Number(lineGraphSelectedValue?.currentAvgStock || 0);
        const oldSafetyStock = Number(lineGraphSelectedValue?.oldSafetyStock || 0);
        const leadTime = Number(row?.leadTime || 0);
        const currLt = Number(
            lineGraphSelectedValue?.purchDocType === "Y1"
                ? lineGraphSelectedValue?.contractLt?.split(" ")[0]
                : lineGraphSelectedValue?.activePirLt?.split(" ")[0]
        );

        const ratio = currLt !== 0 ? Math.sqrt(leadTime / currLt) : 0;
        const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

        const inventoryChange = (currentAvgStock - oldSafetyStock + (oldSafetyStock * ratio)) - currentAvgStock;

        let inventoryValue = (lineGraphSelectedValue.actualPrice * inventoryChange).toFixed(2);
        const updatedRow = { ...lineGraphSelectedValue, inventoryValue: inventoryValue, recomConfidenceLevel: row.percentile, finalLt: Number(row.leadTime), graphFinalLT: Number(row.leadTime), potentialImpact: `${Math.round((Math.sqrt(Number(row.leadTime) / Number(lineGraphSelectedValue?.purchDocType === "Y1" ? lineGraphSelectedValue?.contractLt?.split(" ")[0] : lineGraphSelectedValue?.activePirLt?.split(" ")[0])) - 1) * 100)}%` }
        const getArray = [updatedRow];
        getArray.forEach((updatedRow) => {
            const node = gridApi.getRowNode(updatedRow.runOutputSeqId);
            node.setData(updatedRow);
        });
        setSelectedRows((prevSelected) =>
            prevSelected.map(item =>
                item.runOutputSeqId === updatedRow.runOutputSeqId ? updatedRow : item
            )
        );
    }

    const handleOpenOutboundModal = (row, name) => {
        setOpenOutboundModal(true);
        setOutboundData(row);
        setSelectedName(name)
    }
    const handleCloseOutboundModal = (row) => {
        setOpenOutboundModal(false);
        setOutboundData({});
    }

    const handleOpenLeadTime = (row, name) => {
        setOpenLeadTimeModal(true);
        setLeadTimeData(row);
        setLeadTimeName(name)
    }
    const handleCloseLeadTime = (row) => {
        setOpenLeadTimeModal(false);
        setLeadTimeData({});
    }

    const regularItemsData = activeItem === "Pending Approval" ? ApproverPendingApprovalHeaders(onChangeConfidenceLevel, navigate, getWorkFlowData, activeItem, state, role, handleOpenViewAllModal, handleOpenLineGraphModal, handleOpenLeadTime) : ApproverClosedWorkflowHeaders(onChangeConfidenceLevel, navigate, getWorkFlowData, activeItem, state, role, handleOpenViewAllModal, handleOpenOutboundModal, handleOpenLeadTime)
    const [filteredColumnsData, setFilteredColumnsData] = useState(regularItemsData);
    useEffect(() => {
        getApproverHideColumnsData();
    }, [activeItem]);

    const cardData = [
        { title: "Pending Approval", value: pendingApprovalData?.length },
        { title: "Closed Workflow Items", value: closedData?.length },
    ];
    const callBackFunction = (index, title, url) => {
        setActiveItem(title);
        // clearAllFilters();
        localStorage.setItem("approverActiveItem", title);
        localStorage.setItem("lastVisitedPage", 0);
        currentPageRef.current = 0;
        gridRef.current.paginationGoToPage(0);
    }
    const hasSpecifiedKeyValue = (arr, key, value) => {
        if (!arr) {
            return false;
        }
        if (arr) {
            return arr.every(obj => obj[key].includes(value));
        }
    };

    
    const isFinalLtEditable = (row) => {
        if (!row) return false;
        if (role === "Admin") return false;
        if (activeItem === "Pending Approval") {
        return row?.currentApprovalLevel === 1;
        }
        if (activeItem === "Pending Action") {
        return true;
        }
        return false;
    };

    const onSelectionChanged = (params) => {
        const filteredSelectedRows = [];
        params?.api?.forEachNodeAfterFilter((node) => {
            if (node.isSelected()) {
                filteredSelectedRows.push(node.data);
            }
        });
        setSelectedRows(filteredSelectedRows);
        dispatch(setSelectedItem(filteredSelectedRows));
        const result = filteredSelectedRows?.length > 0 ? hasSpecifiedKeyValue(filteredSelectedRows, 'ltVariations', 'Low') : false;
        setIsSubmitToS4Enabled(!result);
        updateButtonLabel(filteredSelectedRows);
        const reSubmitResult = filteredSelectedRows?.length > 0 ? hasSpecifiedKeyValue(filteredSelectedRows, 'currentStatus', 'Rejected') : false;
        setIsResubmitEnabled(!reSubmitResult);
        const hasEditableFinalLtRows = filteredSelectedRows.length > 0 && filteredSelectedRows.some(isFinalLtEditable);
        setBulkPDTDisabled(!hasEditableFinalLtRows);
        if (hasEditableFinalLtRows) {
        bulkPDTBaseRowsRef.current = filteredSelectedRows
            .filter(isFinalLtEditable)
            .map((row) => ({ ...row }));
        } else {
        setBulkPDTValue("");
        bulkPDTBaseRowsRef.current = [];
        }
    }

    const rowSelection = useMemo(() => {
        if (activeItem === "Pending Approval") {
            return {
                mode: 'multiRow',
            }
        }
        if (activeItem === "Closed Workflow Items") {
            return undefined;
        }
    })
    const selectionColumnDef = useMemo(() => ({
        pinned: 'left'
    }))

    const clearAllFilters = () => {
        if (gridRef.current) {
            gridRef.current.setFilterModel(null);
            setDisableFilterBtn(true);
        }
        localStorage.removeItem("savedVariantFilterModel");
    };

    const onFilterChanged = () => {
        if (gridRef.current) {
            const filterModel = gridRef.current.getFilterModel();
            setDisableFilterBtn(Object.keys(filterModel).length === 0);
        }
    };

    const gridOptions = {
        getRowId: (params) => {
            return `${params?.data?.runOutputSeqId}`
        },
        onFilterChanged,
        overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
        overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
        defaultColDef: {
            sortable: true,
            filter: 'agMultiColumnFilter',
            filterParams: {
                filters: [
                    {
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            suppressMiniFilter: false,
                        },
                    },
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            excelMode: 'windows',
                            suppressMiniFilter: false,
                            buttons: ['apply', 'reset'],
                        },
                    },
                ],
            },
            autoHeight: true,
            cellStyle: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: 1.5,
                display: "flex",
                alignItems: "center",
            },
            valueGetter: (params) => {
                if (!params.data) return "-";

                const field = params.colDef.field;
                const value = params.data[field];

                return value === null || value === undefined || value === "" ? "-" : value;
            },
        }

    }
    useEffect(() => {
        checkVariantFilter()
    }, [gridApi]);

    const handleCreateVariantModal = () => {
        setVariantData(gridApi?.getFilterModel());
        setOpenCreateVariantModal(true);
    }

    const handleCloseCreateVariantModal = () => {
        setOpenCreateVariantModal(false)
    }
    const handleShowVariantModal = () => {
        setOpenShowVariantModal(true);
    }

    const handleCloseShowVariantModal = () => {
        setOpenShowVariantModal(false)
    }
    const onClickSelectVariant = (variant) => {
        if (!gridApi || !variant?.filterJson) return;

        try {
            const filterModel =
                typeof variant.filterJson === "string"
                    ? JSON.parse(variant.filterJson)
                    : variant.filterJson;

            localStorage.setItem("savedVariantFilterModel", JSON.stringify(filterModel));
            gridApi.setFilterModel(filterModel);
            gridApi.onFilterChanged();
        } catch (e) {
            console.error("Invalid filterJson:", variant.filterJson, e);
        }
    };

    const onCellValueChanged = (params) => {
        const { colId } = params.column;
        const { data } = params;
        if (selectedRows.some(row => row.runOutputSeqId === params.data.runOutputSeqId)) {
            const updatedSelectedRows = selectedRows.map(row =>
                row.runOutputSeqId === params.data.runOutputSeqId ? params.data : row
            );
            setSelectedRows(updatedSelectedRows);
        }

        if (colId === "finalLt") {
            const currLt = Number(
                params?.data?.purchDocType === "Y1"
                    ? params?.data?.contractLt?.split(" ")[0]
                    : params?.data?.activePirLt?.split(" ")[0]
            );
            const ratio = Math.sqrt(Number(params?.data?.finalLt || 0) / currLt);
            const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

            const inventoryChange =
                (params?.data?.currentAvgStock - params?.data?.oldSafetyStock + (params?.data?.oldSafetyStock * ratio)) -
                params?.data?.currentAvgStock;

            let inventoryValue = (params?.data?.actualPrice * inventoryChange).toFixed(2);
            params.node.setDataValue('potentialImpact', `${Math.round((Math.sqrt(Number(params?.data?.finalLt || 0) / Number(params?.data?.purchDocType === "Y1" ? params?.data?.contractLt?.split(" ")[0] : params?.data?.activePirLt?.split(" ")[0])) - 1) * 100)}%`);
            params.node.setDataValue('inventoryValue', inventoryValue);
            setEditedRows((prevEditedRows) => {
                const existingRowIndex = prevEditedRows.findIndex(row => row.runOutputSeqId === data.runOutputSeqId);
                if (existingRowIndex > -1) {
                    const updatedEditedRows = [...prevEditedRows];
                    updatedEditedRows[existingRowIndex] = data;
                    return updatedEditedRows;
                } else {
                    return [...prevEditedRows, data];
                }
            });
        }
        if (colId === 'recomConfidenceLevel') {
            const currLt = Number(
                params?.data?.purchDocType === "Y1"
                    ? params?.data?.contractLt?.split(" ")[0]
                    : params?.data?.activePirLt?.split(" ")[0]
            );
            const ratioLikely = Math.sqrt(Number(params?.data?.likelyFinalLt || 0) / currLt);
            const ratioLessLikely = Math.sqrt(Number(params?.data?.lessLikelyFinalLt || 0) / currLt);
            const ratioHighLikely = Math.sqrt(Number(params?.data?.highLikelyFinalLt || 0) / currLt);
            if (params.data.recomConfidenceLevel === "75%") {
                const inventoryChangeLikely =
                    (params?.data?.currentAvgStock - params?.data?.oldSafetyStock + (params?.data?.oldSafetyStock * ratioLikely)) -
                    params?.data?.currentAvgStock;
                let inventoryValueLikely = (params?.data?.actualPrice * inventoryChangeLikely).toFixed(2);

                params.node.setDataValue('finalLt', params?.data?.likelyFinalLt);
                params.node.setDataValue('potentialImpact', `${Math.round((Math.sqrt(Number(params?.data?.likelyFinalLt || 0) / Number(params?.data?.purchDocType === "Y1" ? params?.data?.contractLt?.split(" ")[0] : params?.data?.activePirLt?.split(" ")[0])) - 1) * 100)}%`);
                params.node.setDataValue('inventoryValue', inventoryValueLikely);
            } else if (params.data.recomConfidenceLevel === "65%") {
                const inventoryChangeLessLikely =
                    (params?.data?.currentAvgStock - params?.data?.oldSafetyStock + (params?.data?.oldSafetyStock * ratioLessLikely)) -
                    params?.data?.currentAvgStock;
                let inventoryValueLessLikely = (params?.data?.actualPrice * inventoryChangeLessLikely).toFixed(2);
                params.node.setDataValue('finalLt', params?.data?.lessLikelyFinalLt);
                params.node.setDataValue('potentialImpact', `${Math.round((Math.sqrt(Number(params?.data?.lessLikelyFinalLt || 0) / Number(params?.data?.purchDocType === "Y1" ? params?.data?.contractLt?.split(" ")[0] : params?.data?.activePirLt?.split(" ")[0])) - 1) * 100)}%`);
                params.node.setDataValue('inventoryValue', inventoryValueLessLikely);
            } else if (params.data.recomConfidenceLevel === "85%") {
                const inventoryChangeHighLikely =
                    (params?.data?.currentAvgStock - params?.data?.oldSafetyStock + (params?.data?.oldSafetyStock * ratioHighLikely)) -
                    params?.data?.currentAvgStock;
                let inventoryValueHighLikely = (params?.data?.actualPrice * inventoryChangeHighLikely).toFixed(2);
                params.node.setDataValue('finalLt', params?.data?.highLikelyFinalLt);
                params.node.setDataValue('potentialImpact', `${Math.round((Math.sqrt(Number(params?.data?.highLikelyFinalLt || 0) / Number(params?.data?.purchDocType === "Y1" ? params?.data?.contractLt?.split(" ")[0] : params?.data?.activePirLt?.split(" ")[0])) - 1) * 100)}%`);
                params.node.setDataValue('inventoryValue', inventoryValueHighLikely);
            }
        }
    };

    const handleAddBulkPDT = (event) => {
        const value = event.target.value;
        setBulkPDTValue(value);

        const numericValue = Number(value);
        if (value === "" || Number.isNaN(numericValue)) {
        if (value === "") {
            const restoredRows = selectedRows.map((row) => {
            if (!isFinalLtEditable(row)) {
                return row;
            }

            const baseRow = bulkPDTBaseRowsRef.current.find(
                (base) => base.runOutputSeqId === row.runOutputSeqId
            ) || row;

            const currLt = Number(
                row?.purchDocType === "Y1"
                ? row?.contractLt?.split(" ")[0]
                : row?.activePirLt?.split(" ")[0]
            );
            const ratio = Math.sqrt(Number(baseRow?.finalLt || 0) / currLt);
            const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;
            const inventoryChange =
                (row?.currentAvgStock - row?.oldSafetyStock + (row?.oldSafetyStock * ratio)) -
                row?.currentAvgStock;
            const inventoryValue = (row?.actualPrice * inventoryChange).toFixed(2);

            return {
                ...row,
                finalLt: Number(baseRow?.finalLt || 0),
                potentialImpact,
                inventoryValue,
            };
            });

            setSelectedRows(restoredRows);
            restoredRows.forEach((restoredRow) => {
            if (!isFinalLtEditable(restoredRow) || !gridApi) {
                return;
            }
            const node = gridApi.getRowNode(restoredRow.runOutputSeqId);
            if (node) {
                node.setData(restoredRow);
            }
            });
        }
        return;
        }

        const updatedSelectedRows = selectedRows.map((row) => {
        if (!isFinalLtEditable(row)) {
            return row;
        }

        const baseRow = bulkPDTBaseRowsRef.current.find(
            (base) => base.runOutputSeqId === row.runOutputSeqId
        ) || row;

        // const currentFinalLt = Number(baseRow?.finalLt || 0);
        // const newFinalLt = currentFinalLt + numericValue;
        const newFinalLt = numericValue;
        const currLt = Number(
            row?.purchDocType === "Y1"
            ? row?.contractLt?.split(" ")[0]
            : row?.activePirLt?.split(" ")[0]
        );
        const ratio = Math.sqrt(Number(newFinalLt || 0) / currLt);
        const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;
        const inventoryChange =
            (row?.currentAvgStock - row?.oldSafetyStock + (row?.oldSafetyStock * ratio)) -
            row?.currentAvgStock;
        const inventoryValue = (row?.actualPrice * inventoryChange).toFixed(2);

        return {
            ...row,
            finalLt: newFinalLt,
            potentialImpact,
            inventoryValue,
        };
        });

        setSelectedRows(updatedSelectedRows);
        setEditedRows((prevEditedRows) => {
        const updatedEditedRows = [...prevEditedRows];
        updatedSelectedRows.forEach((updatedRow) => {
            const existingRowIndex = updatedEditedRows.findIndex(row => row.runOutputSeqId === updatedRow.runOutputSeqId);
            if (existingRowIndex > -1) {
            updatedEditedRows[existingRowIndex] = updatedRow;
            } else {
            updatedEditedRows.push(updatedRow);
            }
        });
        return updatedEditedRows;
        });

        updatedSelectedRows.forEach((updatedRow) => {
        if (!isFinalLtEditable(updatedRow) || !gridApi) {
            return;
        }
        const node = gridApi.getRowNode(updatedRow.runOutputSeqId);
        if (node) {
            node.setData(updatedRow);
        }
        });
    };

    const closeFinalLTUpdateModal = () => {
        setOpenFinalLTUpdateModal(false)
    }
    const onClickFinalLTUpdateSubmitButton = (finalLTValue) => {

        setOpenFinalLTUpdateModal(false);
        const updatedSelectedRows = selectedRows.map(row => {
            const currLt = Number(
                row?.purchDocType === "Y1"
                    ? row?.contractLt?.split(" ")[0]
                    : row?.activePirLt?.split(" ")[0]
            );

            const ratio = Math.sqrt(Number(finalLTValue) / currLt);
            const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

            const inventoryChange =
                (row?.currentAvgStock - row?.oldSafetyStock + (row?.oldSafetyStock * ratio)) -
                row?.currentAvgStock;

            let inventoryValue = (row?.actualPrice * inventoryChange).toFixed(2);

            const updatedRow = { ...row, finalLt: Number(finalLTValue), potentialImpact: potentialImpact, inventoryValue }
            return updatedRow;
        });
        updatedSelectedRows.forEach((updatedRow) => {
            const node = gridApi.getRowNode(updatedRow.runOutputSeqId);
            node.setData(updatedRow);
        });
        gridApi.deselectAll();
        updatedSelectedRows.forEach((updatedRow) => {
            const node = gridApi.getRowNode(updatedRow.runOutputSeqId);
            node.setSelected(true);
        });
        setEditedRows(updatedSelectedRows)
    }

    const handleTextAreaChange = (e) => {
        setTextAreaValue(e.target.value);
    }

    const handleReject = async () => {

        const list = [];
        selectedRows?.map((item) => list.push({
            "runOutputSeqId": item.runOutputSeqId,
            "level": item.currentApprovalLevel,
            "userLt": item.finalLt,
            "confidenceLevel": item.recomConfidenceLevel,
            "recommendedLt": item.recomConfidenceLevel === "85%" ? item.highLikelyFinalLt : item?.graphFinalLT || item.finalLt
        }))

        const rejectBody = {
            "userEmail": localStorage.getItem("data"),
            "userRemarks": textAreaValue,
            "updateWorkflowsList": list
        }
        try {
            const responseReject = await dispatch(rejectPlannerByApprover({
                dynamicEndpoint: `${rejectPlannerByApproverEndpoint}`,
                data: rejectBody,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responseReject.meta.requestStatus === 'fulfilled') {
                toast.success(responseReject?.payload, {
                    autoClose: 2000,
                });
                setBulkPDTDisabled(true);
                setBulkPDTValue("");
                setTextAreaValue("");
                setSelectedRows([]);
                setEditedRows([])
                getWorkFlowData();
                setEqualCount(0);
                setNonEqualCount(0);
                setRejectedCount(0);
                setButtonLabel("Approve & Send to Next Level");
            } else {
                toast.error(responseReject?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    const handleRejectToInitiator = async () => {
        const multiApproverList = selectedRows.filter((item) => item?.currentApprovalLevel !== 1)
        // const singleApproverList = selectedRows.filter((item) => item?.currentApprovalLevel === 1)

        const multiApproverListReqbody = [];
        multiApproverList?.map((item) => multiApproverListReqbody.push({
            "runOutputSeqId": item.runOutputSeqId,
            "level": item.currentApprovalLevel,
            "userLt": item.finalLt,
            "confidenceLevel": item.recomConfidenceLevel,
            "recommendedLt": item.recomConfidenceLevel === "85%" ? item.highLikelyFinalLt : item?.graphFinalLT || item.finalLt
        }))

        const rejectToMultiaApproverBody = {
            "userEmail": localStorage.getItem("data"),
            "userRemarks": textAreaValue,
            "updateWorkflowsList": multiApproverListReqbody
        }

        // const singleApproverListReqbody = [];
        // singleApproverList?.map((item) => singleApproverListReqbody.push({
        //     "runOutputSeqId": item.runOutputSeqId,
        //     "level": item.currentApprovalLevel,
        //     "userLt": item.finalLt,
        //     "confidenceLevel": item.recomConfidenceLevel,
        //     "recommendedLt": item.recomConfidenceLevel === "85%" ? item.highLikelyFinalLt : item?.graphFinalLT || item.finalLt
        // }))

        // const rejectToSingleApproverBody = {
        //     "userEmail": localStorage.getItem("data"),
        //     "userRemarks": textAreaValue,
        //     "updateWorkflowsList": singleApproverListReqbody
        // }
        if (multiApproverList?.length > 0) {
            try {
                const responseReject = await dispatch(postRejectToInitiator({
                    dynamicEndpoint: `${rejectToInitiatorEndpoint}`,
                    data: rejectToMultiaApproverBody,
                    params: {
                        plant: localStorage.getItem("selectedLTPlantCode")
                    }
                }));
                if (responseReject.meta.requestStatus === 'fulfilled') {
                    toast.success(responseReject?.payload, {
                        autoClose: 2000,
                    });
                    setBulkPDTDisabled(true);
                    setBulkPDTValue("");
                    setTextAreaValue("");
                    setSelectedRows([]);
                    setEditedRows([])
                    getWorkFlowData();
                    setEqualCount(0);
                    setNonEqualCount(0);
                    setRejectedCount(0);
                    setButtonLabel("Approve & Send to Next Level");
                } else {
                    toast.error(responseReject?.payload?.errorMessage, {
                        autoClose: 2000,
                    });
                }
            } catch (error) {
                console.error('API error:', error);
            }
        }

        //not needed
        // if (singleApproverList?.length > 0) {
        //     try {
        //         const responseReject = await dispatch(rejectPlannerByApprover({
        //             dynamicEndpoint: `${rejectPlannerByApproverEndpoint}`,
        //             data: rejectToSingleApproverBody,
        //             params: {
        //                 plant: localStorage.getItem("selectedLTPlantCode")
        //             }
        //         }));
        //         if (responseReject.meta.requestStatus === 'fulfilled') {
        //             toast.success(responseReject?.payload, {
        //                 autoClose: 2000,
        //             });
        //             setTextAreaValue("");
        //             setSelectedRows([]);
        //             setEditedRows([])
        //             getWorkFlowData();
        //             setEqualCount(0);
        //             setNonEqualCount(0);
        //             setRejectedCount(0);
        //             setButtonLabel("Approve & Send to Next Level");
        //         } else {
        //             toast.error(responseReject?.payload?.errorMessage, {
        //                 autoClose: 2000,
        //             });
        //         }
        //     } catch (error) {
        //         console.error('API error:', error);
        //     }
        // }


    }

    const handleSendToNextLevel = async () => {

        const bodyList = [];
        selectedRows?.map((item) => bodyList.push({
            "runOutputSeqId": item.runOutputSeqId,
            "level": item.currentApprovalLevel,
            "userLt": item.finalLt,
            "confidenceLevel": item.recomConfidenceLevel,
            "recommendedLt": item.recomConfidenceLevel === "85%" ? item.highLikelyFinalLt : item?.graphFinalLT || item.finalLt
        }))

        const sendToNextLevelBody = {
            "userEmail": localStorage.getItem("data"),
            "userRemarks": textAreaValue,
            "updateWorkflowsList": bodyList
        }

        try {
            const responseSendToNextLevel = await dispatch(sendToNextLevelApprover({
                dynamicEndpoint: `${sendToNextLevelApproverEndpoint}`,
                data: sendToNextLevelBody,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responseSendToNextLevel.meta.requestStatus === 'fulfilled') {
                toast.success(responseSendToNextLevel?.payload, {
                    autoClose: 2000,
                });
                setBulkPDTDisabled(true);
                setBulkPDTValue("");
                setTextAreaValue("");
                setSelectedRows([]);
                setEditedRows([])
                getWorkFlowData();
                setEqualCount(0);
                setNonEqualCount(0);
                setRejectedCount(0);
                setButtonLabel("Approve & Send to Next Level");
            } else {
                toast.error(responseSendToNextLevel?.payload?.errorMessage, {
                    autoClose: 2000,
                });
                setTextAreaValue("");
                setSelectedRows([]);
                setEqualCount(0);
                setNonEqualCount(0);
                setRejectedCount(0);
                setButtonLabel("Approve & Send to Next Level");
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    const handleMixedItems = async () => {
        const rejectedItems = selectedRows?.filter((row) => row.currentStatus?.includes("Rejected"));
        const nonRejectedItems = selectedRows?.filter((row) => !row.currentStatus?.includes("Rejected"));

        const nonRejectedbodyList = [];
        nonRejectedItems?.map((item) => nonRejectedbodyList.push({
            "runOutputSeqId": item.runOutputSeqId,
            "level": item.currentApprovalLevel,
            "userLt": item.finalLt,
            "confidenceLevel": item.recomConfidenceLevel,
            "recommendedLt": item.recomConfidenceLevel === "85%" ? item.highLikelyFinalLt : item?.graphFinalLT || item.finalLt
        }))

        const sendToNextLevelBody = {
            "userEmail": localStorage.getItem("data"),
            "userRemarks": textAreaValue,
            "updateWorkflowsList": nonRejectedbodyList
        }
        if (nonRejectedItems?.length > 0) {
            try {
                const responseSendToNextLevel = await dispatch(sendToNextLevelApprover({
                    dynamicEndpoint: `${sendToNextLevelApproverEndpoint}`,
                    data: sendToNextLevelBody,
                    params: {
                        plant: localStorage.getItem("selectedLTPlantCode")
                    }
                }));
                if (responseSendToNextLevel.meta.requestStatus === 'fulfilled') {
                    toast.success(responseSendToNextLevel?.payload, {
                        autoClose: 2000,
                    });
                    setTextAreaValue("");
                    setSelectedRows([]);
                    setEditedRows([])
                    getWorkFlowData();
                    setEqualCount(0);
                    setNonEqualCount(0);
                    setRejectedCount(0);
                    setButtonLabel("Approve & Send to Next Level");
                } else {
                    toast.error(responseSendToNextLevel?.payload?.errorMessage, {
                        autoClose: 2000,
                    });
                    setTextAreaValue("");
                    setSelectedRows([]);
                    setEqualCount(0);
                    setNonEqualCount(0);
                    setRejectedCount(0);
                    setButtonLabel("Approve & Send to Next Level");
                }
            } catch (error) {
                console.error('API error:', error);
            }
        }

        const rejectedBodyList = [];
        rejectedItems?.map((item) => rejectedBodyList.push({
            "runOutputSeqId": item.runOutputSeqId,
            "level": item.currentApprovalLevel,
            "userLt": item.finalLt,
            "confidenceLevel": item.recomConfidenceLevel,
            "recommendedLt": item.recomConfidenceLevel === "85%" ? item.highLikelyFinalLt : item?.graphFinalLT || item.finalLt
        }))

        const resubmitBody = {
            "userEmail": localStorage.getItem("data"),
            "userRemarks": textAreaValue,
            "updateWorkflowsList": rejectedBodyList
        }
        if (rejectedCount > 0) {
            try {
                const responseResubmit = await dispatch(resubmitByApprover({
                    dynamicEndpoint: `${reSubmitWorkflowEndpoint}`,
                    data: resubmitBody,
                    params: {
                        plant: localStorage.getItem("selectedLTPlantCode")
                    }
                }));
                if (responseResubmit.meta.requestStatus === 'fulfilled') {
                    toast.success(responseResubmit?.payload, {
                        autoClose: 2000,
                    });
                    setTextAreaValue("");
                    setSelectedRows([]);
                    setEditedRows([])
                    getWorkFlowData();
                    setEqualCount(0);
                    setNonEqualCount(0);
                    setRejectedCount(0);
                    setButtonLabel("Approve & Send to Next Level");
                } else {
                    toast.error(responseResubmit?.payload?.errorMessage, {
                        autoClose: 2000,
                    });
                    setTextAreaValue("");
                    setSelectedRows([]);
                    setEqualCount(0);
                    setNonEqualCount(0);
                    setRejectedCount(0);
                    setButtonLabel("Approve & Send to Next Level");
                }
            } catch (error) {
                console.error('API error:', error);
            }
        }
    }

    const handleResubmit = async () => {

        const bodyList = [];
        selectedRows?.map((item) => bodyList.push({
            "runOutputSeqId": item.runOutputSeqId,
            "level": item.currentApprovalLevel,
            "userLt": item.finalLt,
            "confidenceLevel": item.recomConfidenceLevel,
            "recommendedLt": item.recomConfidenceLevel === "85%" ? item.highLikelyFinalLt : item?.graphFinalLT || item.finalLt
        }))

        const resubmitBody = {
            "userEmail": localStorage.getItem("data"),
            "userRemarks": textAreaValue,
            "updateWorkflowsList": bodyList
        }

        try {
            const responseResubmit = await dispatch(resubmitByApprover({
                dynamicEndpoint: `${reSubmitWorkflowEndpoint}`,
                data: resubmitBody,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responseResubmit.meta.requestStatus === 'fulfilled') {
                toast.success(responseResubmit?.payload, {
                    autoClose: 2000,
                });
                setBulkPDTDisabled(true);
                setBulkPDTValue("");
                setTextAreaValue("");
                setSelectedRows([]);
                setEditedRows([])
                getWorkFlowData();
                setEqualCount(0);
                setNonEqualCount(0);
                setRejectedCount(0);
                setButtonLabel("Approve & Send to Next Level");
            } else {
                toast.error(responseResubmit?.payload?.errorMessage, {
                    autoClose: 2000,
                });
                setTextAreaValue("");
                setSelectedRows([]);
                setEqualCount(0);
                setNonEqualCount(0);
                setRejectedCount(0);
                setButtonLabel("Approve & Send to Next Level");
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    const handleColumnChange = (event) => {
        setSelectedColumns(event.target.value);
    };

    const renderDropdownValue = (selected) => {
        if (selected?.length === 0) return "Select Columns";
        if (selected?.length === 1) return columnFilterDropdownOption.find(col => col?.headerName === selected?.[0])?.headerName;

        const firstColumnName = columnFilterDropdownOption.find(col => col?.headerName === selected?.[0])?.headerName;
        return `${firstColumnName}, +${selected?.length - 1}`;
    };

    const handleSave = async () => {

        const responseBody = {
            "userEmail": userEmail,
            "hiddenColumns": selectedColumns
        }

        try {
            const responsePostAdminHideColumns = await dispatch(postApproverHideColumnsAPI({
                dynamicEndpoint: `${postLTApproverHideColumnsEndpoint}`,
                data: responseBody,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responsePostAdminHideColumns?.meta?.requestStatus === 'fulfilled') {
                getApproverHideColumnsData();
                handleCloseHide();
            } else {
                console.error('Failed to fetch data:', responsePostAdminHideColumns?.error);
            }
        } catch (error) {
            console.error('API error:', error);
        }

        const displayedColumns = regularItemsData.filter(
            col => !col.optionalField || !selectedColumns.includes(col.headerName)
        );
        setFilteredColumnsData([...displayedColumns]);
    }

    const addApproversAPI = async (approversData) => {
        const filteredData = approversData?.filter(item => item.isNotAddApprovers !== true);
        const userEmail = localStorage.getItem("data");
        const runOutputSeqId = selectedRows[0]?.runOutputSeqId;

        const addExtraApproversList = [];
        filteredData.map((item) => {
            addExtraApproversList.push({
                "approverEmail": item.email,
                "approverName": item.name,
                "approverLevel": item.level
            },)
        })

        const addApproversRequestBody = {
            "userEmail": userEmail,
            "runOutputSeqId": runOutputSeqId,
            "extraApproversList": addExtraApproversList
        }

        try {
            const responseAddApprovers = await dispatch(addExtraApproversAPI({
                dynamicEndpoint: `${addApproversEndpoint}`,
                data: addApproversRequestBody,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responseAddApprovers?.meta.requestStatus === 'fulfilled') {
                toast.success(responseAddApprovers?.payload, {
                    autoClose: 2000,
                });
                setTextAreaValue("");
                setSelectedRows([]);
                setEditedRows([])
                getWorkFlowData();
                setEqualCount(0);
                setNonEqualCount(0);
                setRejectedCount(0);
                setButtonLabel("Approve & Send to Next Level");
            } else {
                toast.error(responseAddApprovers?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error(error, {
                autoClose: 2000,
            });
        }
    }

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClickHide = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseHide = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        (stateSelector?.GetApproverResultsSlice?.loading || stateSelector?.SendToNextLevelSlice?.loading || stateSelector?.RejectPlannerByApproverSlice?.loading || stateSelector?.ResubmitSlice?.loading) ?
            <Loader />
            :
            <div>
                <TopSection tabTitle="Approval Management" labelList={[{ title: 'Home', path: '/landing-page' }, { title: 'Approval Management' }]} />
                <div className="card_container">
                    <Cards cards={cardData} showBorder={true} callBackFunction={callBackFunction} />
                </div>
                <div><p id="activeItem_Workflow">{activeItem}</p></div>
                <div
                    style={{
                        border: "1px solid lightgrey",
                        borderRadius: "6px",
                        padding: "10px",
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '5px 0px 10px 0px' }}>
                        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                            <div style={{ display: 'flex', gap: 10 }}>
                                <IconButton onClick={handleClickHide}>
                                    <Badge badgeContent={badgeCount > 0 ? badgeCount : null} sx={{
                                        "& .MuiBadge-badge": {
                                            fontSize: "0.6rem", // Smaller font size
                                            height: "16px", // Adjust badge height
                                            minWidth: "16px", // Adjust badge width
                                            padding: "4px", // Adjust padding
                                            background: '#000',
                                            color: '#fff'
                                        },
                                    }}
                                    >
                                        <MoreVertIcon />
                                    </Badge>
                                </IconButton>

                                <Popover
                                    open={Boolean(anchorEl)}
                                    anchorEl={anchorEl}
                                    onClose={handleCloseHide}
                                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                                    className="hidePopover"
                                    sx={{
                                        marginTop: 1,
                                        marginLeft: 0,
                                    }}
                                >
                                    <div style={{ padding: 10, width: 150 }}>
                                        <p style={{ marginBottom: 10, marginTop: 5 }}>Hide Columns</p>
                                        <Select
                                            multiple
                                            value={selectedColumns}
                                            onChange={handleColumnChange}
                                            renderValue={renderDropdownValue}
                                            displayEmpty
                                            sx={{ backgroundColor: "#fff", border: '1px solid #000', width: '100%', height: 35, marginBottom: 5 }}
                                        >
                                            <MenuItem disabled value="">
                                                <em>Select Columns</em>
                                            </MenuItem>
                                            {columnFilterDropdownOption.map(col => (
                                                <MenuItem key={col.headerName} value={col.headerName}>
                                                    <Checkbox checked={selectedColumns.includes(col.headerName)} />
                                                    <ListItemText primary={col.headerName} />
                                                </MenuItem>
                                            ))}

                                        </Select>
                                        {stateSelector?.PostApproverHideColumns?.loading ?
                                            <Box style={{ textAlign: 'center' }}>
                                                <CircularProgress color="inherit" style={{ width: '20px', height: '20px', textAlign: 'center' }} />
                                            </Box>
                                            :
                                            <ButtonComponent type="secondary" label="Save" onClick={handleSave} />
                                        }
                                    </div>
                                </Popover>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'end', gap: 10 }}>
                                <ButtonComponent
                                    maxWidth="150px"
                                    label="Clear All Filters"
                                    bgColor="black"
                                    color="white"
                                    disabled={disableFilterBtn}
                                    onClick={clearAllFilters}
                                />
                                <ButtonComponent
                                    maxWidth="180px"
                                    label="Create/Edit Variant"
                                    bgColor="black"
                                    color="white"
                                    // disabled={Object.keys(gridApi?.getFilterModel() || {}).length === 0}
                                    onClick={handleCreateVariantModal}
                                />
                                <ButtonComponent
                                    maxWidth="150px"
                                    label="Show Variants"
                                    bgColor="black"
                                    color="white"
                                    onClick={handleShowVariantModal}
                                />
                                {
                                role !== "Admin" &&
                                <TextInput
                                    name="bulkPDTValue"
                                    type="number"
                                    value={bulkPDTValue}
                                    onChange={handleAddBulkPDT}
                                    label="Bulk PDT"
                                    width="150px"
                                    disabled={bulkPDTDisabled}
                                />
                                }
                            </div>
                        </div>

                        {activeItem !== "Closed Workflow Items" && role !== "Admin" &&
                            <div style={{ display: 'flex', justifyContent: 'end', margin: '5px 0px 10px 0px' }}>
                                <span style={{ fontSize: 14, textDecoration: 'underline', cursor: (selectedRows?.length === 0 || selectedRows?.length === undefined) ? "auto" : 'pointer', color: (selectedRows?.length === 0 || selectedRows?.length === undefined) ? "#bcbcbc" : "#000" }} onClick={() => selectedRows?.length !== 0 && setOpenFinalLTUpdateModal(true)}>LT to be updated against selected items</span>
                                <FinalLTUpdateModal openFinalLTUpdateModal={openFinalLTUpdateModal} closeFinalLTUpdateModal={closeFinalLTUpdateModal} onClickSubmitButton={onClickFinalLTUpdateSubmitButton} />
                            </div>}
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <div>
                            {filteredData && <DataTable
                                ref={gridRef}
                                columns={filteredColumnsData}
                                rows={filteredData || []}
                                paginationProp={pagination}
                                paginationPageSize={paginationPageSize}
                                paginationPageSizeSelector={paginationPageSizeSelector}
                                onGridReady={onGridReady}
                                onSelectionChanged={onSelectionChanged}
                                headerCheckboxSelectionFilterOnly={true}
                                rowSelection={rowSelection}
                                selectionColumnDef={selectionColumnDef}
                                gridOptions={gridOptions}
                                cellEditorParams={cellEditorParams}
                                stopEditingWhenCellsLoseFocus={true}
                                onCellValueChanged={onCellValueChanged}
                                onPaginationChanged={onPaginationChanged}
                                onFirstDataRendered={onFirstDataRendered}
                            />}
                        </div>
                        <div>
                            <VariantViewModal tableType={"LT_APPROVER"} openCreateVariantModal={openCreateVariantModal} handleCloseCreateVariantModal={handleCloseCreateVariantModal} data={variantData} />
                        </div>
                        <div>
                            <ShowVariantViewModal tableType={"LT_APPROVER"} openShowVariantModal={openShowVariantModal} handleCloseShowVariantModal={handleCloseShowVariantModal} data={variantData} onClickSelectVariant={onClickSelectVariant} />
                        </div>
                        <div>
                            <LeadtimeModel data={viewAllData} openViewAllModal={openViewAllModal} loading={stateSelector?.ViewAllLineItemsDataSlice?.loading} handleCloseViewAllModal={handleCloseViewAllModal} />
                        </div>
                        <div>
                            <LeadTimeLineGraph openLineGraph={openLineGraph} lineGraphSelectedValue={lineGraphSelectedValue} handleCloseLineGraphModal={handleCloseLineGraphModal} handleSaveModal={handleSaveLineGraphModal} />
                        </div>
                        <div>
                            <OutBoundDataModal data={outboundData} selectedName={selectedName} openOutboundModal={openOutboundModal} handleCloseOutboundModal={handleCloseOutboundModal} />
                        </div>
                        <div>
                            <CPLeadTimeModal data={leadTimeData} leadTimeName={leadTimeName} openLeadTimeModal={openLeadTimeModal} handleCloseLeadTime={handleCloseLeadTime} />
                        </div>
                        {(activeItem !== "Closed Workflow Items" && role !== "Admin") &&
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                                <span style={{ fontSize: 12 }}>Remarks for Acceptance/Rejection*</span>
                                <TextareaAutosize disabled={selectedRows?.length === 0 || selectedRows?.length === undefined} minRows={3} style={{ width: '300px', fontSize: 14 }} onChange={handleTextAreaChange} value={textAreaValue} />
                            </div>}
                    </div>
                    {activeItem === "Pending Approval" &&
                        <div style={{ display: 'flex', margin: '10px 0px', justifyContent: 'flex-end', gap: 10 }}>
                            <AddExtraApproverModal runOutputSeqId={selectedRows[0]?.runOutputSeqId} disableEditApproversButton={(selectedRows?.length !== 1 || selectedRows?.length === undefined)} addApproversAPI={addApproversAPI} setBulkPDTDisabled={setBulkPDTDisabled} setBulkPDTValue={setBulkPDTValue} />
                            <ButtonComponent
                                type="secondary"
                                maxWidth="200px"
                                label="Reject to Initiator"
                                onClick={handleRejectToInitiator}
                                disabled={(selectedRows?.length === 0 || selectedRows?.length === undefined) || textAreaValue?.length === 0 || disableRejectToInitiator}
                            />
                            <ButtonComponent
                                type="secondary"
                                maxWidth="200px"
                                label="Reject to Previous Level"
                                onClick={handleReject}
                                disabled={(selectedRows?.length === 0 || selectedRows?.length === undefined) || textAreaValue?.length === 0}
                            />
                            {equalCount > 0 && nonEqualCount === 0 && rejectedCount === 0 &&
                                <ButtonComponent
                                    maxWidth="240px"
                                    type="secondary"
                                    label={"Approve & Send to S/4"}
                                    onClick={handleSendToNextLevel}
                                    disabled={(selectedRows?.length === 0 || selectedRows?.length === undefined) || textAreaValue?.length === 0}
                                />
                            }
                            {equalCount === 0 && nonEqualCount > 0 && rejectedCount === 0 &&
                                <ButtonComponent
                                    maxWidth="240px"
                                    type="secondary"
                                    label={"Approve & Send to Next Level"}
                                    onClick={handleSendToNextLevel}
                                    disabled={(selectedRows?.length === 0 || selectedRows?.length === undefined) || textAreaValue?.length === 0}
                                />
                            }
                            {equalCount === 0 && nonEqualCount === 0 && rejectedCount > 0 &&
                                <ButtonComponent
                                    maxWidth="240px"
                                    type="secondary"
                                    label={"Approve & Resubmit"}
                                    onClick={handleResubmit}
                                    disabled={(selectedRows?.length === 0 || selectedRows?.length === undefined) || textAreaValue?.length === 0}
                                />
                            }
                            {selectedRows?.length === 0 &&
                                <ButtonComponent
                                    maxWidth="240px"
                                    type="secondary"
                                    label={"Approve & Send to Next Level"}
                                    disabled={(selectedRows?.length === 0 || selectedRows?.length === undefined) || textAreaValue?.length === 0}
                                />
                            }
                            {((equalCount > 0 && nonEqualCount > 0) || (equalCount > 0 && rejectedCount > 0) || (rejectedCount > 0 && nonEqualCount > 0)) && <SendToNextLevel activeItem={activeItem} singleApproverCount={equalCount} multiLevelApproverCount={nonEqualCount} reSubmitCount={rejectedCount} rowCount={selectedRows?.length} disabled={(selectedRows?.length === 0 || selectedRows?.length === undefined) || textAreaValue?.length === 0} handleSendToNextLevelAPI={handleMixedItems} setBulkPDTDisabled={setBulkPDTDisabled} setBulkPDTValue={setBulkPDTValue} />}

                        </div>
                    }
                </div>

            </div>
    );
};

export default ApproverManagement;
